<template>
  <div id="software-management">
    <TopBarComponent title="IP100 Warehouse Bulk Upload" />
    <div style="position: relative; display: flex; flex-grow: 1; background-color: #e5ecf0;">
      <AdminMenuComponent
        id="menu-tlm-component"
        :class="sideMenuClass"
        class="collapse-anim"
      />
      <router-view id="content" />
    </div>
  </div>
</template>

<script>

import TopBarComponent from '../components/TopBarComponent.vue'
import AdminMenuComponent from '../components/AdminMenuComponent.vue'

export default {

	components: {
		TopBarComponent,
		AdminMenuComponent
	},
  	data () {
		return {
			username: 'chris.danguien@sky.uk',
			sideMenuClass: 'side-menu-collapsed',
			toggleButtonClass: ''
		}
	},
	mounted () {
		console.debug('Home mounted')
		this.$router.push('/home')
	},

	methods: {
		toggleCollapse: function () {
			console.log('toggleCollpase')

			if (this.sideMenuClass.includes('side-menu-not-collapse')) {
				console.log('Hide Menu')
				this.sideMenuClass = 'side-menu-collapsed'
				this.toggleButtonClass = 'toggle-button-visible'
			} else {
				console.log('Show Menu')

				this.sideMenuClass = 'side-menu-not-collapse'
				this.toggleButtonClass = 'toggle-button-hidden'
			}
		},

		swipeLeftMenu: function () {
			if (this.toggleButtonClass.includes('toggle-button-hidden')) {
				this.sideMenuClass = 'side-menu-collapsed'
				this.toggleButtonClass = 'toggle-button-visible'
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
#software-management
  height: 100%;
  display: flex;
  flex-direction: column;

#menu-button-toggle
  position: absolute;
  top: 1%;
  right: 2%;
  background: #00a3d8;
  border: none;
  border-radius: 1.4rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  color: #fff;
  font-size: 14pt;

#menu-button-toggle:focus, #menu-button-toggle:active {
  outline: none;
}

#menu-tlm-component {
  width: 20%;

  @media screen and (max-width: 800px) {
    width: 30%;
  }

  @media screen and (max-width: 600px) {
    width: 35%;
  }
/*
  @media screen and (max-width: 1000px) {
    width: 30%;
  }
  */
}

#content {
  flex-grow: 1;

  background-color: #E5ECF0;

  padding: 1rem;
}

.collapse-anim
  -webkit-transition: margin-left 0.5s, opacity 0.5s; /* Safari */
  transition: margin-left 0.5s, opacity 0.5s;

.side-menu-not-collapse
  margin-left: 0%;

  opacity: 1;

.side-menu-collapsed
  margin-left: 0%;

  @media screen and (max-width: 600px) {
    margin-left: -35%;

    opacity: 0;
  }

  overflow: hidden;

.toggle-button-visible {
  visibility : visible;
}

.toggle-button-hidden {
  visibility: hidden;
}

</style>
